
export { useUkAwareText } from "/home/runner/work/capsicum/capsicum/libs/socios-core/shared/regulations/hooks/useUkAwareText.ts"
export { worldChampionshipDisclaimerAtom } from "/home/runner/work/capsicum/capsicum/libs/socios-core/shared/world-championship-event/data-access/index.ts"